import React from 'react'
import { styled } from '@mui/material/styles'
import { WallChartEventBarStyleProps } from './types'
import { ColourSchemeProps } from '../../LegendsFooter/types'
import { getPalleteTypeByProp } from '../../../theme/palette'

const colorScheme = (eventType: string): ColourSchemeProps => {
  const palletObject = getPalleteTypeByProp(eventType.toLowerCase())
  if (!palletObject) {
    return { backgroundColour: 'lightgray', fontColour: 'gray' }
  }
  return { backgroundColour: palletObject.color, fontColour: palletObject.fontColor }
}

export const WallChartEventBar = styled(
  'div',
  {}
)<Partial<WallChartEventBarStyleProps>>(({ status, recordTypeStr, position, zIndex, isVisible, style }) => ({
  ...{
    backgroundColor: colorScheme(recordTypeStr!).backgroundColour,
    height: '10px',
    width: position!.widthPercent,
    position: 'absolute',
    left: position!.startPercent,
    borderRadius: '20px',
    opacity: isVisible ? 1 : 0,
    zIndex,
    transition: 'all 0.3s ease-in-out',
    ...style,
  },
  ...((status?.toLowerCase() === 'pending' || status?.toLowerCase() === 'change requested') && {
    backgroundImage:
      'linear-gradient(135deg, transparent  37.50%, rgb(68 68 68 / 30%) 37.50%, rgb(68 68 68 / 30%) 50%, transparent  50%, transparent  87.50%, rgb(68 68 68 / 30%) 87.50%, rgb(68 68 68 / 30%) 100%)',
    backgroundSize: '10px 10px',
  }),
  ...(position!.extendedLeft && { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
  ...(position!.extendedRight && { borderTopRightRadius: 0, borderBottomRightRadius: 0 }),
})) as React.ComponentType<Partial<WallChartEventBarStyleProps>>
